export var StageOption;
(function(StageOption) {
    StageOption["DRAFT"] = "DRAFT";
    StageOption["PUBLISHED"] = "PUBLISHED";
})(StageOption || (StageOption = {}));
